import { Fragment, useState, useEffect, useContext } from 'react';
import { useNavigate,useLoaderData } from "react-router-dom";
import ModalStepper from '../components/Login/ModalStepper';

import TestHeader from '../components/TestsHeader/TestsHeader';
import CategorySuperMenu from '../components/Categories/CategorySuperMenu';
import CategoryMenu from '../components/Categories/CategoryMenu';
import CategoryModal from '../components/Categories/CategoryModal';
import AvailableTests from '../components/Tests/AvailableTests';
import AvailableTestwithCat from '../components/Tests/AvailableTestwithCat';

import { getLabConfig, getCategories, getTableForm, getSystemMsg } from '../utils/api';

import MenuContext from '../store/MenuContext';
import CartClasses from '../components/Cart/Cart.module.css';

const Home = () => {
	const navigate = useNavigate();

	// Modal Step Control
	const [modalStep, setModalStep] = useState(0); 
	const [adultsOnly, setAdultsOnly] = useState([]);
	const [tFFilters, setTFFilters] = useState([]);
	const [superCat, setSuperCat] = useState([]);
	const [hasCategories, setHasCategories] = useState(false);
	
	const menuTheme = useContext(MenuContext);

	const {landing,banner}=useLoaderData();
	// Determine which modal to show first
	useEffect(() => {
		async function initModals() {
			const adultsOnly2 = await getLabConfig('DTCADULTONLY');
			sessionStorage.setItem("DTCADULTONLY",adultsOnly2)
			setAdultsOnly(adultsOnly2);

			const filters = await getTableForm('DTC:Patient', 'Filters');
			setTFFilters(filters);

			const isAdult = sessionStorage.getItem("Adult") === "Yes";
			const hasLabTestId = sessionStorage.getItem("Labtestid") !== null;
			const hasFilter1 = sessionStorage.getItem("Filter1") !== null;

			if (adultsOnly2 === 'On' && !isAdult && !hasLabTestId) {
				setModalStep(1); // Show AdultsOnly
			} else if (filters.length && filters[0].Display === true && !hasFilter1 && !hasLabTestId) {
				setModalStep(2); // Show FilterUsers
			} else if (filters.length && filters[2]?.Display === true && !hasLabTestId) {
				setModalStep(3); // Show OrderTest
			} else if (landing && Object.keys(landing).length > 0)  {
				setModalStep(4); //show landing message
			}

		}

		initModals();
	}, []);

	// SEO setup
	const [HomeTitle, setHomeTitle] = useState('');
	const [PortalTitle, setPortalTitle] = useState([]);
	const [canonicalUrl, setCanonicalUrl] = useState('');
	useEffect(() => {
        async function fetchPortalTitle() {
            const portalTitle = await getLabConfig('DTCLABEL');
            setPortalTitle(portalTitle);
        }
        fetchPortalTitle();
    }, []);
	useEffect(() => {
		async function setupSEO() {
			const homeTitle = await getLabConfig("DTCHTMLTITLE");
			const metaDescription = await getLabConfig("DTCMETADESCRIPTION");
			const metaKeywords = await getLabConfig("DTCMETAKEYWORDS");
			const canonicalUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
			setHomeTitle(homeTitle);
			// === Description Tag ===
			let descTag = document.querySelector("meta[name='description']");
			if (!descTag) {
			  descTag = document.createElement('meta');
			  descTag.setAttribute('name', 'description');
			  document.head.appendChild(descTag);
			}
			descTag.setAttribute('content', metaDescription);

			// === Keywords Tag ===
			let keywordsTag = document.querySelector("meta[name='keywords']");
			if (!keywordsTag) {
			  keywordsTag = document.createElement('meta');
			  keywordsTag.setAttribute('name', 'keywords');
			  document.head.appendChild(keywordsTag);
			}
			keywordsTag.setAttribute('content', metaKeywords);

			// === Canonical Link Tag ===
			let canonicalTag = document.querySelector("link[rel='canonical']");
			if (!canonicalTag) {
			  canonicalTag = document.createElement('link');
			  canonicalTag.setAttribute('rel', 'canonical');
			  document.head.appendChild(canonicalTag);
			}
			canonicalTag.setAttribute('href', canonicalUrl);

	  }
	  setupSEO();
	}, []);

	useEffect(() => {
		document.title = HomeTitle;
		return () => {
			document.title = PortalTitle;
		};
	}, [HomeTitle]);


	// Fetch Super Categories
	useEffect(() => {
		async function fetchSuperCategories() {
			const data = await getCategories('1');
			setSuperCat(data);
		}
		fetchSuperCategories();
	}, []);
		//Fetch all categories to determine if categories should be displayed at all
    useEffect(() => {
        async function fetchCategories() {
            const fetchedCategories = await getCategories('0');
            if(fetchedCategories.length>0) {
				setHasCategories(true);
			}
        }

        fetchCategories();
    }, []);
	return (
		<Fragment>
			{/* Sequential Modal Controller */}
			<ModalStepper
				step={modalStep}
				setStep={setModalStep}
				filters={tFFilters}
				cartClasses={CartClasses}
				navigate={navigate}
				message={landing}
			/>

			{/* Layout rendering */}
			{menuTheme === "TOP" && (
				<AvailableTestwithCat />
			)}

			{menuTheme === "HAMBURGER" && (
				<>
					{superCat ? (
						<main className='mainLayout'>
							<CategorySuperMenu />
						</main>
					) : (
						<main className='mainLayout'>
							{hasCategories &&
								<CategoryMenu />
							}
							<AvailableTests superCat={superCat} page='first' />
						</main>
					)}
				</>
			)}
		</Fragment>
	);
};

export default Home;

export async function loader() {
    const response = await getSystemMsg("Landing");
	const resData = await response;
	const response2 = await getSystemMsg("Banner");
	const resData2 = await response2;
	  return {
			landing: resData,
			banner: resData2
		  };
}